import React, { useState } from "react";
import Form from "../../../Partials/Layouts/Forms/Form";
import ShortTextInput from "../../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput";
import ImageInput from "../../../Partials/Layouts/Forms/FormInputs/ImageInput/ImageInput";
import FormSubmitButton from "../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton";
import { GalleryItem_API } from "../../../../Utilities/APIs";
import CustomEditor from "../../../Partials/Elements/CustomEditor/CustomEditor";
import useAxiosInstance from "../../../../Utilities/Hooks/useAxiosInstance";

function CreateGalleryItem({
  setShowCreateForm,
  setShowModal,
  triggerFetch,
  galleryId,
}) {
  const [image, setImage] = useState("");
  const [precedence, setPrecedence] = useState(0);
  const axiosInstance = useAxiosInstance();

  async function handleSubmit(e) {
    e.preventDefault();
    const itemData = new FormData();
    itemData.append("galleryId", galleryId);
    itemData.append("precedence", precedence);
    itemData.append("image", image);

    console.log(image);
    const response = await axiosInstance.post(
      GalleryItem_API,
      itemData
    );

    console.log(response);
    if (response.data) {
      setShowCreateForm(false);
      setShowModal(false);
      triggerFetch();
    }
  }

  return (
    <Form onSubmit={handleSubmit} hasImage>
      <ShortTextInput
        fieldId="2"
        label={`Precedence`}
        state={precedence}
        setState={setPrecedence}
        placeholder="precedence"
      />
      <ImageInput
      label={`Gallery Image`}
        fieldId="1"
        state={image}
        setState={setImage}
        allowCreateImage
      >
        Upload Gallery Image
      </ImageInput>
      <FormSubmitButton text="Create" />
    </Form>
  );
}
export default CreateGalleryItem;
